// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Equipments_equipments__oij0N {
  display: flex;
  flex-direction: column;
}
.Equipments_equipments__lists-container__HiBhq {
  margin-top: 31px;
  display: flex;
  flex-direction: column;
  gap: 31px;
}
.Equipments_equipments__oij0N .Equipments_list__CW757 {
  display: flex;
  flex-direction: column;
}
.Equipments_equipments__oij0N .Equipments_list__title__r1Gty {
  margin-bottom: 8px;
}
.Equipments_equipments__oij0N .Equipments_list__container__2xDUA {
  display: grid;
  grid-template-columns: repeat(2, calc(50% - 6px));
  gap: 12px;
}
.Equipments_equipments__oij0N .Equipments_list__CW757 .Equipments_equipment-item__T-NX6 {
  padding: 16px;
  background: #FFFFFF;
  border-radius: 12px;
  box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.0509803922);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}
.Equipments_equipments__oij0N .Equipments_list__CW757 .Equipments_equipment-item__T-NX6 .Equipments_info__PjspZ {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.Equipments_equipments__oij0N .Equipments_list__CW757 .Equipments_equipment-item__T-NX6 .Equipments_info__name__LUPH\\+ {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.Equipments_equipments__oij0N .Equipments_list__CW757 .Equipments_equipment-item__T-NX6 .Equipments_info__inventory__me\\+RP {
  color: #7A808B;
}
.Equipments_equipments__oij0N .Equipments_list__CW757 .Equipments_equipment-item__T-NX6 .Equipments_info__dates__lBx\\+S {
  display: flex;
  gap: 8px;
}
.Equipments_equipments__oij0N .Equipments_list__CW757 .Equipments_equipment-item__T-NX6 .Equipments_info__dates__lBx\\+S span {
  padding: 4px 10px;
  background: #EEEEEE;
  border-radius: 12px;
  display: flex;
  gap: 5px;
  align-items: center;
  font-size: 12px;
  line-height: 12px;
}
.Equipments_equipments__oij0N .Equipments_list__CW757 .Equipments_equipment-item__T-NX6 .Equipments_info__dates__lBx\\+S .Equipments_start__xv6nf svg {
  margin: 2px;
  fill: #41C061;
}
.Equipments_equipments__oij0N .Equipments_list__CW757 .Equipments_equipment-item__T-NX6 .Equipments_info__dates__lBx\\+S .Equipments_end__DNoCd svg {
  margin: 2px;
  fill: #F2200D;
}
.Equipments_equipments__oij0N .Equipments_list__CW757 .Equipments_equipment-item__T-NX6 .Equipments_icon__ruuej {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  flex-shrink: 0;
}
.Equipments_equipments__oij0N .Equipments_list__CW757 .Equipments_equipment-item__T-NX6 .Equipments_icon__ruuej svg {
  fill: none;
}
.Equipments_equipments__oij0N .Equipments_list__CW757 .Equipments_equipment-item__T-NX6 .Equipments_icon-story__dmkmO {
  background: #EFF3F5;
}
.Equipments_equipments__oij0N .Equipments_list__CW757 .Equipments_equipment-item__T-NX6 .Equipments_icon-active__EY8xE {
  background: #ECF9EF;
}
.Equipments_equipments__oij0N .Equipments_list__CW757 .Equipments_equipment-item__T-NX6 .Equipments_icon-wait__4XOgW {
  background: #FDF6E7;
}
.Equipments_equipments__oij0N .Equipments_tooltip__kNpAM {
  background-color: rgba(29, 34, 46, 0.2117647059);
  color: #fff;
  line-height: 1.4em;
  font-size: 12px;
  max-width: 300px;
  padding: 10px;
  border-radius: 8px;
}
.Equipments_equipments__mobile__LstMJ .Equipments_equipments__lists-container__HiBhq {
  margin-top: 24px;
  gap: 24px;
}
.Equipments_equipments__mobile__LstMJ .Equipments_list__container__2xDUA {
  grid-template-columns: repeat(1, 100%);
}

.Equipments_equipment-loader__s-n5t {
  height: 78px;
  border-radius: 12px;
}

.Equipments_modal__-wgIC {
  padding: 12px;
  align-items: flex-end;
}
.Equipments_modal__content-container__kR-5h {
  display: flex;
  flex-direction: column;
}
.Equipments_modal__-wgIC .Equipments_info-container__qJlDz {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}
.Equipments_modal__-wgIC .Equipments_item__OhNzh {
  display: flex;
  flex-direction: column;
  padding-bottom: 12px;
  border-bottom: 1px solid #F3F2F2;
}
.Equipments_modal__-wgIC .Equipments_item__name__Ut4kr {
  font-size: 12px;
  line-height: 13.68px;
  color: #54575C;
}
.Equipments_modal__-wgIC .Equipments_item__content__dBrbH {
  font-size: 16px;
  font-weight: 500;
  line-height: 18.24px;
}
.Equipments_modal__-wgIC header {
  border-bottom: none;
  font-size: 22px;
  font-weight: 600;
  line-height: 25.08px;
}
.Equipments_modal__-wgIC header .modal__close-btn {
  margin-bottom: auto;
}

.Equipments_noEquipment__4ZSWU {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 114%;
  margin: auto;
  width: 100%;
  position: absolute;
  top: 50%;
}
@media (min-width: 1200px) {
  .Equipments_noEquipment__4ZSWU {
    position: initial;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Equipment/Equipments.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;AACE;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;AAAJ;AAEI;EACE,kBAAA;AAAN;AAGI;EACE,aAAA;EACA,iDAAA;EACA,SAAA;AADN;AAII;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uDAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAFN;AAIM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAFR;AAIQ;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAFV;AAKQ;EACE,cAAA;AAHV;AAMQ;EACE,aAAA;EACA,QAAA;AAJV;AAMU;EACE,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAJZ;AAQY;EACE,WAAA;EACA,aAAA;AANd;AAWY;EACE,WAAA;EACA,aAAA;AATd;AAeM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAbR;AAeQ;EACE,UAAA;AAbV;AAgBQ;EACE,mBAAA;AAdV;AAiBQ;EACE,mBAAA;AAfV;AAkBQ;EACE,mBAAA;AAhBV;AAsBE;EACE,gDAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AApBJ;AAwBI;EACE,gBAAA;EACA,SAAA;AAtBN;AAyBI;EACE,sCAAA;AAvBN;;AA4BA;EACE,YAAA;EACA,mBAAA;AAzBF;;AA4BA;EACE,aAAA;EACA,qBAAA;AAzBF;AA2BE;EACE,aAAA;EACA,sBAAA;AAzBJ;AA4BE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AA1BJ;AA6BE;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,gCAAA;AA3BJ;AA6BI;EACE,eAAA;EACA,oBAAA;EACA,cAAA;AA3BN;AA8BI;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;AA5BN;AAiCI;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AA/BN;AAiCM;EACE,mBAAA;AA/BR;;AAqCA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;AAlCF;AAoCE;EAVF;IAWI,iBAAA;EAjCF;AACF","sourcesContent":[".equipments {\n  display: flex;\n  flex-direction: column;\n\n  &__lists-container {\n    margin-top: 31px;\n    display: flex;\n    flex-direction: column;\n    gap: 31px;\n  }\n\n  .list {\n    display: flex;\n    flex-direction: column;\n\n    &__title {\n      margin-bottom: 8px;\n    }\n\n    &__container {\n      display: grid;\n      grid-template-columns: repeat(2, calc(50% - 6px));\n      gap: 12px;\n    }\n\n    .equipment-item {\n      padding: 16px;\n      background: #FFFFFF;\n      border-radius: 12px;\n      box-shadow: 0px 5px 9px 0px #0000000D;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: 12px;\n\n      .info {\n        display: flex;\n        flex-direction: column;\n        gap: 12px;\n\n        &__name {\n          display: -webkit-box;\n          -webkit-line-clamp: 1;\n          -webkit-box-orient: vertical;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n\n        &__inventory {\n          color: #7A808B;\n        }\n\n        &__dates {\n          display: flex;\n          gap: 8px;\n\n          span {\n            padding: 4px 10px;\n            background: #EEEEEE;\n            border-radius: 12px;\n            display: flex;\n            gap: 5px;\n            align-items: center;\n            font-size: 12px;\n            line-height: 12px;\n          }\n\n          .start {\n            svg {\n              margin: 2px;\n              fill: #41C061;\n            }\n          }\n\n          .end {\n            svg {\n              margin: 2px;\n              fill: #F2200D;\n            }\n          }\n        }\n      }\n\n      .icon {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        flex-shrink: 0;\n\n        svg {\n          fill: none;\n        }\n\n        &-story {\n          background: #EFF3F5;\n        }\n\n        &-active {\n          background: #ECF9EF;\n        }\n\n        &-wait {\n          background: #FDF6E7;\n        }\n      }\n    }\n  }\n\n  .tooltip {\n    background-color: #1d222e36;\n    color: #fff;\n    line-height: 1.4em;\n    font-size: 12px;\n    max-width: 300px;\n    padding: 10px;\n    border-radius: 8px;\n  }\n\n  &__mobile {\n    .equipments__lists-container {\n      margin-top: 24px;\n      gap: 24px;\n    }\n\n    .list__container {\n      grid-template-columns: repeat(1, 100%);\n    }\n  }\n}\n\n.equipment-loader {\n  height: 78px;\n  border-radius: 12px;\n}\n\n.modal {\n  padding: 12px;\n  align-items: flex-end;\n\n  &__content-container {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .info-container {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-bottom: 16px;\n  }\n\n  .item {\n    display: flex;\n    flex-direction: column;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #F3F2F2;\n\n    &__name {\n      font-size: 12px;\n      line-height: 13.68px;\n      color: #54575C;\n    }\n\n    &__content {\n      font-size: 16px;\n      font-weight: 500;\n      line-height: 18.24px;\n    }\n  }\n\n  :global {\n    header {\n      border-bottom: none;\n      font-size: 22px;\n      font-weight: 600;\n      line-height: 25.08px;\n  \n      .modal__close-btn {\n        margin-bottom: auto;\n      }\n    }\n  }\n}\n\n.noEquipment {\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 114%;\n  margin: auto;\n  width: 100%;\n  position: absolute;\n  top: 50%;\n\n  @media (min-width: 1200px) {\n    position: initial;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"equipments": `Equipments_equipments__oij0N`,
	"equipments__lists-container": `Equipments_equipments__lists-container__HiBhq`,
	"list": `Equipments_list__CW757`,
	"list__title": `Equipments_list__title__r1Gty`,
	"list__container": `Equipments_list__container__2xDUA`,
	"equipment-item": `Equipments_equipment-item__T-NX6`,
	"info": `Equipments_info__PjspZ`,
	"info__name": `Equipments_info__name__LUPH+`,
	"info__inventory": `Equipments_info__inventory__me+RP`,
	"info__dates": `Equipments_info__dates__lBx+S`,
	"start": `Equipments_start__xv6nf`,
	"end": `Equipments_end__DNoCd`,
	"icon": `Equipments_icon__ruuej`,
	"icon-story": `Equipments_icon-story__dmkmO`,
	"icon-active": `Equipments_icon-active__EY8xE`,
	"icon-wait": `Equipments_icon-wait__4XOgW`,
	"tooltip": `Equipments_tooltip__kNpAM`,
	"equipments__mobile": `Equipments_equipments__mobile__LstMJ`,
	"equipment-loader": `Equipments_equipment-loader__s-n5t`,
	"modal": `Equipments_modal__-wgIC`,
	"modal__content-container": `Equipments_modal__content-container__kR-5h`,
	"info-container": `Equipments_info-container__qJlDz`,
	"item": `Equipments_item__OhNzh`,
	"item__name": `Equipments_item__name__Ut4kr`,
	"item__content": `Equipments_item__content__dBrbH`,
	"noEquipment": `Equipments_noEquipment__4ZSWU`
};
export default ___CSS_LOADER_EXPORT___;
